export default {"src":"/_next/static/media/lgPay.cfde6cd4.svg","height":349,"width":1333,"blurWidth":0,"blurHeight":0};